import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

const ViewDetails = ({ confirmData, confirmDataHandle }) => {
    useEffect(() => {
        if (!confirmData.isClosePopup) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.position = '';
        }

    }, [confirmData]);

    return !confirmData.isClosePopup ? (
        <div className={styles.confirm}>
            <div className={styles.confirmBox}>
                <div className={styles.confirmTitle}>
                    《發現新主播》是鳳凰衛視選拔、儲備優秀國際傳播人才的一檔大型活動，由鳳凰衛視委託北京鳳凰匯播傳媒有限公司（以下簡稱“鳳凰匯播”）拍攝製作成為專題節目，用作鳳凰衛視及旗下自有頻道及合作的第三方平台播出。<br />
                    該節目由鳳凰新媒體有限公司之附屬公司北京天盈九州網絡技術有限公司運營的鳳凰網（www.ifeng.com）（“鳳凰新媒體/鳳凰網”）為你提供【發現新主播】平台，作為上傳報名資訊及其他資料的唯一官方入口。<br />
                    為了更好地保護你的權益，請務必審慎閱讀、充分理解以下內容及授權。如你不同意以下內容或其中任何條款，你應立即停止使用【發現新主播】平台。 你點擊“同意”，則視為你已閱讀並同意以下內容及授權，將在你與北京天盈九州網絡技術有限公司之間產生法律效力。<br />
                    1、節目完成片及一切素材的智慧財產權屬於鳳凰衛視或鳳凰匯播所有，承諾人同意不以任何形式主張對節目的版權及收益權。<br />
                    2.承諾人確認鳳凰衛視對節目擁有最終審核權，有權決定在鳳凰衛視所屬頻道以及其他自有頻道（包括但不限於鳳凰秀、鳳凰網以及鳳凰衛視和附屬機構在社交媒體註冊的賬號上）和第三方平台（包括但不限於全球範圍內的電視媒體、網路媒體、社交媒體、自媒體）播出並獲取收益。<br />
                    3.承諾人同意鳳凰衛視及鳳凰匯播在本節目中使用本人的肖像，同意鳳凰衛視在第2條所述範圍對節目進行宣傳和播映時使用本人肖像。<br />
                    4.承諾人同意嚴格保守保密資訊（包括但不限於節目資料、尚未公開的節目創作、方案策劃，樣片，文稿，素材，影像及圖片等）。<br />
                    5.承諾人提交給鳳凰衛視參與本次活動選拔的影片內容，需確保其真實、合法性。並確保影片內容中涉及的主要出鏡人同意鳳凰衛視及其自有頻道平台使用其肖像，並確保所提供的節目影片內容，包括但不限於拍攝人物、場景、畫面、配音、音樂和其他的音影片資料等均已獲得權利人的許可或授權。承諾人同意鳳凰衛視可以在第2條所述管道為節目播出、活動宣傳及節目推廣需要使用該等影片。由於承諾人提交的影片內容瑕疵引發的爭議由承諾人負責。<br />
                    6.承諾人同意在參與節目拍攝製作過程中，因自身原因發生人身意外損傷或財產損失，與鳳凰衛視及北京鳳凰匯播傳媒有限公司無涉。<br />
                    7.承諾人在參與節目製作過程中，不得以鳳凰衛視的名義進行任何形式的招商和行銷活動，亦不得做出有損鳳凰衛視及鳳凰匯播公司名譽的行為。<br />
                    8、以上承諾條款，若承諾人違反，鳳凰衛視及鳳凰匯播公司均有權向承諾人追究法律責任。<br />
                    <div className={styles.space_100} />
                </div>
                <div className={styles.confirmOperate}>
                    <div
                        className={styles.confirmYes}
                        onClick={() => {
                            confirmDataHandle({ isClickOk: false, isCheck: true, isClosePopup: true });
                        }}>
                        不同意
                    </div>
                    <div
                        className={styles.confirmCancel}
                        onClick={() => {
                            confirmDataHandle({ isClickOk: true, isCheck: false, isClosePopup: true });
                        }}>
                        我同意
                    </div>
                </div>
                <div
                    className={styles.confirmClose}
                    onClick={() => {
                        confirmDataHandle({
                            ...confirmData,
                            isClosePopup: true
                        });
                    }}
                />
            </div>
        </div>
    ) : null;
};

ViewDetails.propTypes = {
    confirmData: PropTypes.object,
    confirmDataHandle: PropTypes.func,
};

export default errorBoundary(ViewDetails);
